import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, Row, Col, Checkbox, Upload, notification, message, Space } from 'antd'
import { useLazyGetProductQuery, useRegisterAuctionMutation } from '../../../../../redux/api/ProductApi'
import { format, fromUnixTime } from "date-fns";
import { useUploadFileForObjectMutation, useUploadFileMutation } from "../../../../../redux/api/FileApi";
import { fileTypes } from "../../../../common/types/types";
import { useLazyGetUserInfoQuery } from '../../../../../redux/api/AccountApi'
import { exportFile } from '../../../../common/ts/CommonFunctions';
import { ReactComponent as XIcon } from '../../../../../assets/images/x_icon.svg'
import ConfirmModal from '../../../../common/components/ConfirmModal'
import SuccessModal from './SuccessModal'

type Props = {
    visible: boolean,
    itemId: number,
    statuteId: number,
    toggleModal: () => void,
    onSuccess: () => void,
}

interface RegisterDetail {
    productName: string,
    name: string,
    dob: string,
    identification: string,
    address: string,
    email: string,
    phone: string,
    roleCodes: string[],
    orgName?: string,
    orgNumber?: string,
    orgAddress?: string,
    orgEmail?: string,
}

const RegisterAuction = ({ visible, itemId, statuteId, toggleModal, onSuccess }: Props) => {
    const [form] = Form.useForm()
    const { confirm } = Modal;
    const [registerDetail, registerResponse] = useLazyGetProductQuery()
    const [details, setDetails] = useState<RegisterDetail>()
    const [uploadFile] = useUploadFileMutation();
    const [uploadFileForObject] = useUploadFileForObjectMutation();
    const [deleteIds, setDeleteIds] = useState<number[]>([]);
    const [trigger, response] = useLazyGetUserInfoQuery()
    const uploadFileTypes = ['image/png', 'image/jpeg', 'image/png', '.doc', '.docx', 'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', '.pdf', 'application/pdf'];
    const [uploadedFiles, setUploadedFiles] = useState<[]>();
    const [modalVisible, setModalVisible] = useState(false);
    const [pressExit, setPressExit] = useState(false);
    const [register, { isLoading }] = useRegisterAuctionMutation();
    const [successVisible, setSuccessVisible] = useState(false);
    const [uploadErrorVisible, setUploadErrorVisible] = useState(false);

    useEffect(() => {
        registerDetail({ productId: itemId, statuteId })
        trigger({})
    }, [registerDetail, itemId, trigger, statuteId])


    useEffect(() => {
        if (itemId) {
            if (registerResponse.data && response.data) {
                let dob = response.data?.roleCodes?.includes("ORGANIZATION") ? response.data?.representativeDateOfBirth : response.data?.dateOfBirth
                let address = [
                    ...response.data.address ? [response.data.address] : [],
                    ...response.data.commune?.communeName ? [response.data.commune.communeName] : [],
                    ...response.data.district?.districtName ? [response.data.district?.districtName] : [],
                    ...response.data.province?.provinceName ? [response.data.province?.provinceName] : [],
                ];
                let representativeAddress: any = []
                if (response.data?.roleCodes?.includes("ORGANIZATION")) {
                    representativeAddress = [
                        ...response.data.representativeAddress ? [response.data.representativeAddress] : [],
                        ...response.data.representativeCommune?.communeName ? [response.data.representativeCommune.communeName] : [],
                        ...response.data.representativeDistrict?.districtName ? [response.data.representativeDistrict?.districtName] : [],
                        ...response.data.representativeProvince?.provinceName ? [response.data.representativeProvince?.provinceName] : [],
                    ]
                }

                let currenDetails: RegisterDetail = {
                    productName: registerResponse.data.productName || '',
                    name: (response.data?.roleCodes?.includes("ORGANIZATION") ? response.data.representativeName : response.data.fullName) || '',
                    dob: dob ? format(fromUnixTime(dob / 1000), "dd/MM/yyyy") : "",
                    identification: (response.data?.roleCodes?.includes("ORGANIZATION") ? response.data.representativeIdentificationNumber : response.data.identificationNumber) || '',
                    address: (response.data?.roleCodes?.includes("ORGANIZATION") ? representativeAddress.join(", ") : address.join(", ")) || '',
                    email: (response.data?.roleCodes?.includes("ORGANIZATION") ? response.data.representativeEmail : response.data.email) || '',
                    phone: (response.data?.roleCodes?.includes("ORGANIZATION") ? response.data.representativePhone : response.data.phoneNumber) || '',
                    roleCodes: response.data.roleCodes || [],
                    orgName: response.data.fullName || '',
                    orgNumber: response.data.businessRegistrationNumber || '',
                    orgAddress: address.join(", ") || '',
                    orgEmail: response.data.email || '',
                }
                setDetails(currenDetails)
            }
        }
    }, [itemId, registerResponse, response])

    const normFile = (e: any) => {
        return e.fileList;
    };

    const beforeUpload = (files: File[]) => {
        let accepted = true;
        Array.from(files).forEach(file => {
            if (!uploadFileTypes.includes(file.type)) {
                accepted = false;
                message.error('Định dạng file không hợp lệ!', 5);
            }
            if (file.size / (1024 * 1024) > 5) {
                accepted = false;
                message.error('Dung lượng file không hợp lệ', 5);
            }
        })

        return accepted || Upload.LIST_IGNORE;
    }

    const onFileRemove = (item: any, index: number) => {
        return new Promise<boolean>((resolve, reject) => {
            confirm({
                className: "custom-modal",
                title: 'Xoá file đã chọn?',
                onOk: () => {
                    if (uploadedFiles) {
                        let newDeleteIds = deleteIds;
                        newDeleteIds.push(item.response?.attachmentId);
                        setDeleteIds(newDeleteIds);
                        let newUploadedFiles = uploadedFiles;
                        newUploadedFiles.splice(index, 1);
                        setUploadedFiles([...newUploadedFiles])

                        if (!newUploadedFiles.length) {
                            setUploadErrorVisible(true);
                        }
                    }
                },
                onCancel: () => {
                    resolve(false);
                },
                okText: "Xác nhận",
                cancelText: "Hủy bỏ",
            })
        })
    }

    const customUpload = (options: any, type: string) => {
        options.onProgress({ percent: 0 })
        let formData = new FormData();
        formData.append('file', options.file);
        setUploadErrorVisible(false);
        uploadFile({
            file: formData,
            objectType: fileTypes.REGISTER_AUCTION,
            // storageType: type || "registerAuction",
        }).unwrap()
            .then(res => {
                options.onProgress({ percent: 100 });
                options.onSuccess(res, options.file);
                // setFileList({ ...fileList, [type]: res.attachmentId });
                // console.log('res', res)
                // let newFileList: any = {}
                // console.log('fileList ', fileList)
                // fileList.registerAuction.forEach((item: any) => {
                //     newFileList['registerAuction'].push({
                //         uid: item.uid,
                //         name: item.name
                //     })
                // })
                // newFileList['registerAuction'].push({
                //     uid: res.attachmentId,
                //     name: res.fileName
                // })
                // setFileList(newFileList)
                // fileList.push({ uid: res.attachmentId, name: res.fileName })
                // setFileList(fileList)
                // console.log('filelist', fileList)
            }).catch(err => {
                options.onError();
            })
    }

    const uploadFileAfterSubmit = (id: number, values: any) => {
        let fileIds = values ? values.map((item: any) => item.response.attachmentId) : [];

        uploadFileForObject({
            listFileIds: fileIds,
            objectId: id,
            objectType: fileTypes.REGISTER_AUCTION,
        }).unwrap().then(res => {
            //toggle
            toggleSuccessModal();
            onSuccess();
        }
        ).catch(err => {
            notification.error({
                message: err.data?.message || "Upload file thất bại!"
            })
        })
    }

    const onUploadChange = (e: any) => {
        e.fileList.forEach((list: any) => {
            if (list.uid === e.file.uid) {
                list.url = `${process.env.REACT_APP_API_URL}/files/downloadFile/${list.uid}`;
            }
            if (e.fileList.length) {
                setUploadedFiles(e.fileList);
            }
        });
    }
    const downloadFile = (id: number, name: string) => {
        exportFile(process.env.REACT_APP_API_URL + "/files/downloadFile/" + id, name);
    }

    const noSave = () => {
        setPressExit(false)
        toggleWarning()
        toggleModal()
    }

    const onOk = () => {
        if (!uploadedFiles?.length) {
            setUploadErrorVisible(true);
        } else {
            setPressExit(false)
            toggleWarning()
        }
    }

    const onCancel = () => {
        if (!uploadedFiles || !uploadedFiles.length) {
            toggleModal();
        } else {
            setPressExit(true);
            toggleWarning()
        }
    }

    const toggleSuccessModal = () => {
        setSuccessVisible(!successVisible)
    }

    const toggleSuccess = () => {
        setSuccessVisible(false)
        toggleWarning()
        toggleModal()
    }

    const registerForAuction = () => {
        if (response && registerResponse) {
            register({ userId: response.data?.userId || 0, productId: registerResponse.data?.productId || 0 }).unwrap()
                .then(res => {
                    uploadFileAfterSubmit(res?.bidderId || 0, uploadedFiles)
                })
                .catch(err => {
                    message.error(err?.data?.message, 5);
                })
        }
    }

    const toggleWarning = () => {
        setModalVisible(!modalVisible)
    }
    return (
        <>
            <Modal
                centered
                visible={visible}
                onCancel={onCancel}
                className='custom-modal'
                bodyStyle={{ padding: '60px 105px' }}
                style={{ minWidth: 800 }}
                footer={false}
            >
                <div style={{ textAlign: 'center' }}>
                    <span className="font-size-30">Đăng ký tham gia đấu giá</span>
                </div>

                <Form
                    name="searchBox"
                    form={form}
                    labelAlign="right"
                    colon={false}
                    className='custom-form'
                    style={{ marginTop: 25, marginBottom: 35, fontSize: 16 }}
                >
                    <div style={{ textAlign: 'center' }}>
                        <span>Tên tài sản: {details?.productName}</span>
                    </div>

                    {details?.roleCodes.includes("ORGANIZATION") ?
                        <div className='modal-infobox' style={{ marginTop: 35 }}>
                            <Row>
                                <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                                    <span>Tên tổ chức: </span>
                                </Col>
                                <Col span={16} style={{ textAlign: 'left' }}>
                                    <span className='font-bold'>{details?.orgName} </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                                    <span>Số ĐKKD: </span>
                                </Col>
                                <Col span={16} style={{ textAlign: 'left' }}>
                                    <span className='font-bold'>{details?.orgNumber} </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                                    <span>Địa chỉ: </span>
                                </Col>
                                <Col span={16} style={{ textAlign: 'left' }}>
                                    <span className='font-bold'>{details?.orgAddress} </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                                    <span>Email: </span>
                                </Col>
                                <Col span={16} style={{ textAlign: 'left' }}>
                                    <span className='font-bold'>{details?.orgEmail} </span>
                                </Col>
                            </Row>
                        </div> : <></>}

                    <div className='modal-infobox' style={{ marginTop: 35 }}>
                        <Row>
                            <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                                <span>{!details?.roleCodes.includes("ORGANIZATION") ? "Họ tên: " : "Người đại diện: "}</span>
                            </Col>
                            <Col span={16} style={{ textAlign: 'left' }}>
                                <span className='font-bold'>{details?.name} </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                                <span>Ngày sinh: </span>
                            </Col>
                            <Col span={16} style={{ textAlign: 'left' }}>
                                <span className='font-bold'>{details?.dob} </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                                <span>Địa chỉ: </span>
                            </Col>
                            <Col span={16} style={{ textAlign: 'left' }}>
                                <span className='font-bold'>{details?.address} </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                                <span>Email: </span>
                            </Col>
                            <Col span={16} style={{ textAlign: 'left' }}>
                                <span className='font-bold'>{details?.email} </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                                <span>Số điện thoại: </span>
                            </Col>
                            <Col span={16} style={{ textAlign: 'left' }}>
                                <span className='font-bold'>{details?.phone}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                                <span>CMT/CCCD/ Hộ chiếu: </span>
                            </Col>
                            <Col span={16} style={{ textAlign: 'left' }}>
                                <span className='font-bold'>{details?.identification}</span>
                            </Col>
                        </Row>
                    </div>


                    <div style={{ textAlign: 'center', fontWeight: 700, marginTop: 30 }}>
                        <span className='font-size-16'>File đính kèm: </span>
                    </div>

                    <div style={{ textAlign: 'center' }}>
                        <span className='font-size-12'>Các giấy tờ yêu cầu cụ thể trong quy chế <br />
                            Lưu ý: CMND/Hộ chiếu/CCCD/Giấy ĐKKD đã có trên hệ thống bạn không cần upload lại tại đây!
                            (Vui lòng chọn tài liệu định dạng PDF, DOC, DOCX, JPG, JPEG, PNG dung lượng nhỏ hơn 5MB)</span>
                    </div>

                    <div className='upload-container'>
                        {uploadedFiles ? uploadedFiles.map((item: any, index: number) => {
                            return (
                                <div className='file-wrapper' key={item?.response?.attachmentId || item.uid}>
                                    <span style={{ cursor: 'pointer' }} onClick={() => downloadFile(item?.response?.attachmentId, item.name)}>{item.name}</span>
                                    <XIcon
                                        onClick={() => onFileRemove(item, index)}
                                        style={{ cursor: 'pointer', width: 20, height: 20, marginLeft: 20, marginBottom: 0 }} />
                                </div>
                            )
                        }) : <></>}
                        <Upload
                            customRequest={(options) => customUpload(options, 'registerAuction')}
                            accept="image/jpg,image/jpeg,image/png,jpg,jpeg,png,doc,docx,application/msword,pdf,
                            application/vnd.openxmlformats-officedocument.wordprocessingml.document,pdf,application/pdf"
                            beforeUpload={(file, fileList) => beforeUpload(fileList)}
                            name="file"
                            listType="text"
                            onChange={(e) => onUploadChange(e)}
                            fileList={uploadedFiles}
                            showUploadList={false}
                            className='upload'
                            multiple
                        >
                            <Button className='selectFile-button' style={{ fontSize: 12, fontWeight: 700 }}>CHỌN FILE</Button>
                        </Upload>
                    </div>
                    {uploadErrorVisible ?
                        <div
                            style={{ textAlign: 'center', color: 'red', marginTop: -20, fontSize: 12, marginBottom: 10 }}>
                            File đính kèm là bắt buộc, vui lòng nhập đầy đủ.
                        </div> : <></>}

                    <Form.Item
                        noStyle
                        name="terms"
                        valuePropName="checked"
                    >
                        <Checkbox
                            style={{ display: 'flex', justifyContent: 'center' }}
                            className="custom-checkbox">
                            Tôi đã hiểu rõ về thông tin tài sản và nội quy quy chế đấu giá
                        </Checkbox>
                    </Form.Item>
                </Form>

                <Space style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button htmlType='button'
                        className="button-gray"
                        style={{ marginLeft: 10, width: 180, height: 50 }}
                        onClick={onCancel}
                    >
                        ĐÓNG
                    </Button>
                    <Button
                        htmlType='button'
                        type='primary'
                        style={{ marginLeft: 10, width: 180, height: 50 }}
                        onClick={onOk}
                        className="button-light-yellow"
                    >
                        ĐĂNG KÝ
                    </Button>
                </Space>
            </Modal>

            {modalVisible &&
                <ConfirmModal
                    isLoading={isLoading}
                    visible={modalVisible}
                    okText={pressExit ? "ĐỒNG Ý" : form.getFieldValue('terms') ? "ĐĂNG KÝ" : "ĐỒNG Ý"}
                    title={pressExit ?
                        <div style={{ textAlign: 'center' }}>
                            <div className="font-size-16">Bạn có chắc chắn muốn thoát và không lưu dữ liệu vừa nhập?</div>
                        </div>
                        : form.getFieldValue('terms') ?
                            <div style={{ textAlign: 'center' }}>
                                <div className="font-size-16">Bạn có chắc chắn muốn đăng
                                    ký tham gia đấu giá không?</div>
                            </div>
                            : <div style={{ textAlign: 'center' }}>
                                <div className="font-size-16">Hãy xác nhận bạn đã đọc và đồng ý với Quy chế đấu giá và các nội dung liên quan</div>
                            </div>}
                    status="error"
                    onOk={pressExit ? noSave : form.getFieldValue('terms') ? registerForAuction : toggleWarning}
                    onCancel={toggleWarning}
                    noCancelButton={pressExit ? false : form.getFieldValue('terms') ? false : true}
                />}

            {successVisible ? <SuccessModal visible={successVisible} onOk={toggleSuccess} /> : <></>}
            {/* <SuccessModal visible={true} onOk={toggleSuccessModal}/> */}
        </>
    )
}

export default RegisterAuction